<mat-form-field *ngIf="currencyArray && currencyArray.length > 0">
  <mat-select
    [(ngModel)]="selectedValue"
    (selectionChange)="selectionChange($event)"
  >
    <mat-option *ngFor="let data of currencyArray" [value]="data.code">
      <img  loading="lazy"  class="mr-2" [src]="data.image"    alt="currency" />{{ data.code }}
    </mat-option>
  </mat-select>
</mat-form-field>
